// extracted by mini-css-extract-plugin
export var button = "_la-2";
export var card = "_la-0";
export var closeButtonContainer = "_la-3";
export var iconContainer = "_la-1";